/* global localStorage */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { withNamespaces } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import PropTypes from 'prop-types';
import defaultsDeep from 'lodash/defaultsDeep';
import get from 'lodash/get';
import compose from 'lodash/fp/compose';
import { Container, MediaQueries } from '../../../styles/Grid';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import { NAVBAR_IDS } from '../../../utils/constants';
import { showElementCss, hideElementCss } from '../../../utils/responsive';
import { RegusLogo } from '../../ui/RegusLogo';
import OpenEnquiryFormButton from '../../ui/OpenEnquiryFormButton';
import * as styles from './index.styles';

const defaultData = {
  CountryPhone: { value: '' },
  ShowStartOver: { value: false },
  StartOverURL: { value: '' },
};

export const exitBuilder = language => {
  const path =
    localStorage.getItem('solutionBuilderEntryPoint') ||
    `/${language.toLowerCase()}`;
  window.location.replace(path);
};

export class SolutionBuilderNav extends SafePureComponent {
  fields = defaultsDeep(this.props.fields, defaultData);

  renderGetInTouchCTA() {
    const { t, rendering } = this.props;
    const componentName = get(rendering, 'componentName', '');
    const getInTouchCta = {
      value: {
        text: t('GetInTouchSBCTA'),
      },
    };
    return (
      <OpenEnquiryFormButton
        customCss={styles.getInTouch}
        linkObject={getInTouchCta}
        componentName={componentName}
      />
    );
  }

  renderRightContent = () => {
    const { t } = this.props;
    const CountryPhone = get(this.fields, 'CountryPhone.value');
    const ShowStartOver = get(this.fields, 'ShowStartOver.value');
    const StartOverURL = get(this.fields, 'StartOverURL.value');

    if (ShowStartOver && StartOverURL) {
      return (
        <div css={[styles.rightContent, hideElementCss(MediaQueries.sm)]}>
          <a css={styles.startOverCta} href={StartOverURL}>
            <i css={styles.startOverCtaIcon} className="icon-refresh" />
            <span css={styles.startOverCtaCopy}>{t('StartOverCTA')}</span>
          </a>
        </div>
      );
    }

    return (
      <div css={styles.rightContent}>
        <div css={showElementCss(MediaQueries.mdAndUp, 'inline')}>
          {this.renderGetInTouchCTA()}
        </div>
        <a href={`tel:${CountryPhone}`} css={styles.phoneNumber}>
          <span css={showElementCss(MediaQueries.lgAndUp, 'inline')}>
            {CountryPhone}
          </span>
          <span css={hideElementCss(MediaQueries.mdAndUp)}>
            <i className="icon-contact" />
          </span>
        </a>
      </div>
    );
  };

  safeRender() {
    const { t } = this.props;
    const language = get(this.props.sitecoreContext, 'route.itemLanguage', '');

    return (
      <Container css={styles.navBar}>
        <button css={styles.exit} onClick={() => exitBuilder(language)}>
          <i className="icon-chevron" css={styles.exitIcon}></i>
          <span css={showElementCss(MediaQueries.mdAndUp, 'inline')}>
            {t('ExitCTA')}
          </span>
        </button>
        <a
          aria-label="regus logo"
          css={[styles.buttonReset, styles.flexWrapper]}
          href={`/${language.toLowerCase()}`}
          id={NAVBAR_IDS.SOLUTION_BUILDER}
        >
          <RegusLogo customCss={styles.regusLogo} />
        </a>
        {this.renderRightContent()}
      </Container>
    );
  }
}

SolutionBuilderNav.displayName = 'SolutionBuilderNav';

SolutionBuilderNav.defaultProps = {
  fields: defaultData,
  t: key => `dict-${key}`,
  language: '',
};

SolutionBuilderNav.propTypes = {
  fields: PropTypes.shape({
    CountryPhone: PropTypes.shape({
      value: PropTypes.string,
    }),
    ShowStartOver: PropTypes.shape({
      value: PropTypes.bool,
    }),
    StartOverURL: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
};

export default compose(
  withSitecoreContext(),
  withNamespaces(),
)(SolutionBuilderNav);
